import { NumberInput } from '@mantine/core'
import classes from './NumberInput.module.css'

export const NumberInputThemeKobo = NumberInput.extend({
  classNames: classes,
})
